let caseSliderThumbs = new Swiper(".js-top-screen-case-slider-thumbs", {
    spaceBetween: 10,
    slidesPerView: 4,
    freeMode: false,
});

let caseSlider = new Swiper(".js-top-screen-case-slider", {
    spaceBetween: 10,
    autoplay: {
        delay: 5000,
        disableOnInteraction: false,
    },
    thumbs: {
        swiper: caseSliderThumbs,
    }
});


// WEBPACK FOOTER //
// ./_src/js/modules/PageCase.js